import styles from "./Section2.module.scss";

export const Section4 = function () {
  return (
    <section id="info-gs" className={`${styles.section2Wrapper} cc--component-container`}>
      <div className={styles.section2Container}>
        <div className={styles.section2Content}>
          <h3>TAKE ADVANTAGE OF A BOOMING INDUSTRY</h3>
          <p>
            Artificial intelligence (AI) is no longer just a futuristic sci-fi trope — it’s here now, and it’s here to
            stay. Innovative technologies are revolutionizing business as we know it, and effective leaders are rising
            to the challenge of transformation.
          </p>
          <p>
            But to truly harness the transformative potential of AI and develop relevant skills, you need to know how
            and when to use it. Deepen your knowledge of AI and its business applications with this online short course.
          </p>
        </div>
      </div>
    </section>
  );
};
